import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const cloudPcManagementRoutes: Routes = [
    {
        path: advaniaServicesSegments.cloudPcManagement,
        loadComponent: () =>
            import('./pages/cloud-pc-management-page/cloud-pc-management.page').then((m) => m.CloudPcManagementPage),
    },
];
